module.exports = __webpack_public_path__ + "img/denmark-mental-and-behavioural-disorders-female.3ac46c54.png";